/* eslint-disable max-lines-per-function */
import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from 'src/app/pages/petitionDetails/pageContext';

type Result = ModelHookResult<{
	isSunriseActionPanelEnabled: boolean;
	isSunriseHeadingEnabled: boolean;
	isSunrisePetitionHeaderEnabled: boolean;
	isSunriseMembershipAwarenessEnabled: boolean;
	isSunrisePetitionUpdatesEnabled: boolean;
	isSunriseShareModuleExperimentEnabled: boolean;
	isSunriseReportAbuseEnabled: boolean;
	isSunriseSharePetitionEnabled: boolean;
	isSunriseSupporterVoicesEnabled: boolean;
	isSunriseSupportersEnabled: boolean;
	isSunriseHeaderExperimentEnabled: 'control' | 'fake_control' | 'variant_a' | 'variant_b';
	sunriseActionPanelExperimentVariation: string;
}>;

// eslint-disable-next-line complexity
export const useIsFullSunriseEnabled = (): Result => {
	const {
		data: {
			featureConfigs: { petitionPageFullSunrise },
		},
	} = usePetitionDetailsPageData();

	const {
		data: {
			fullSunrisePetitionPageShareComponentExperiment,
			fullSunrisePetitionHeaderExperiment,
			fullSunriseActionPanelExperimentVariation,
		},
	} = usePetitionDetailsPageUserData();

	/* We will use the FC to determine if full sunrise is enabled for a given module.
	 * In case a module is being experimented on, we will only fetch the experiment, no need for the FC since
	 * the experiment will use the FC under the hood.
	 */
	const {
		actionPanel,
		membershipAwareness,
		petitionHeading,
		petitionHeader,
		petitionUpdates,
		sharePetition,
		supporterVoices,
		supporters,
		reportAbuse,
	} = petitionPageFullSunrise;

	return {
		data: {
			isSunriseActionPanelEnabled: !!actionPanel?.enabled,
			isSunriseHeadingEnabled: !!petitionHeading?.enabled,
			isSunrisePetitionHeaderEnabled: !!petitionHeader?.enabled,
			isSunriseMembershipAwarenessEnabled: !!membershipAwareness?.enabled,
			isSunrisePetitionUpdatesEnabled: !!petitionUpdates?.enabled,
			isSunriseReportAbuseEnabled: !!reportAbuse?.enabled,
			isSunriseShareModuleExperimentEnabled: !!fullSunrisePetitionPageShareComponentExperiment,
			isSunriseSharePetitionEnabled: !!sharePetition?.enabled,
			isSunriseSupporterVoicesEnabled: !!supporterVoices?.enabled,
			isSunriseSupportersEnabled: !!supporters?.enabled,
			isSunriseHeaderExperimentEnabled: fullSunrisePetitionHeaderExperiment,
			sunriseActionPanelExperimentVariation: fullSunriseActionPanelExperimentVariation,
		},
	};
};
